export const ACTIONS = {
  LOAD_FULL_AIRPORT: 'loadFullAirport',
  LOAD_AIRPORT: 'loadAirport',
  SET_COORDINATES: 'setCoordinates',
  BLOCK_BBOX: 'blockBBOX',
  RESET_BBOX: 'resetBBOX',
  LOAD_POIS_CATALOG: 'loadPoisCatalog',
  LOAD_POIS_LIST: 'loadPoisList',
  LOAD_TILES_BUILDING_FLOOR: 'loadTilesBuildingFloor',
  LOAD_FLOOR: 'loadFloor',
  LOAD_POI: 'loadPOI',
  CLEAR_POI: 'clearPOI',
  LOAD_ROUTE: 'loadRoute',
  REMOVE_STEP: 'removeStep',
  CLEAR_ROUTE: 'clearRoute',
  MOVE_ROUTE: 'moveRoute',
  GET_ROUTE: 'getRoute',
  SET_DESTINATION_NAME: 'setDestinationName',
  GET_LINE_ROUTE: 'getLineRoute',
  LOAD_ACTIVE_FILTERS: 'loadActiveFilters',
  LOAD_VIEW: 'loadView',
  ADD_LAYER: 'addLayer',
  UPDATE_LAYER: 'updateLayer',
  DELETE_LAYER: 'deleteLayer',
  SET_PMR_PROFILE: 'setPMRProfile',
  SET_FEEDBACK: 'setFeedback',
  LOAD_ACCESS_CONTROL_TIME: 'loadAccessControlTime',
  SET_HOME_POSITION: 'setHomePosition'
}

export const GETTERS = {
  GET_DEVICE_WIDTH: 'getDeviceWidth',
  GET_IS_MOBILE: 'getIsMobile',
  GET_ID: 'getId',
  GET_LANGUAGE: 'getLanguage',
  GET_EXPLORERMODE: 'getExplorerMode',
  GET_AIRPORT: 'getAirport',
  GET_AIRPORT_ID: 'getAirportId',
  GET_CARTOGRAPHY_TILES: 'getCartographyTiles',
  GET_FLOOR: 'getFloor',
  GET_CATEGORY: 'getCategory',
  GET_SUBCATEGORIES: 'getSubcategories',
  GET_BUILDING_ID: 'getBuildingId',
  GET_FLOOR_ID: 'getFloorId',
  GET_ROUTE_CONFIG: 'getRouteConfig',
  GET_BUILDING: 'getBuilding',
  GET_BUILDINGS: 'getBuildings',
  GET_POI_ID: 'getPOIId',
  GET_POID_ID: 'getPOIDId',
  GET_POI: 'getPOI',
  GET_POI_GROUPED: 'getPOIGrouped',
  GET_BLOCK_BBOX: 'getBlockBBOX',
  GET_BBOX: 'getBBOX',
  GET_COORDINATES: 'getCoordinates',
  GET_ZOOM: 'getZoom',
  GET_ACCESS_TOKEN: 'getAccessToken',
  GET_POIS_CATALOG: 'getPoisCatalog',
  GET_POIS_LIST: 'getPoisList',
  GET_TRANSITION_POIS_LIST: 'getTransitionPoisList',
  GET_UNCATEGORIZED_POIS_LIST: 'getuncategorizedPoisList',
  GET_ACTIVE_FILTERS: 'getActiveFilters',
  GET_ROUTE: 'getRoute',
  IS_ROUTE_MODE: 'isRouteMode',
  HAS_ROUTE: 'hasRoute',
  GET_ROUTE_DEFAULT_LEVEL_BUILDING: 'getRouteDefaultLevelBuilding',
  GET_ORIGIN: 'getOrigin',
  GET_DESTINATION: 'getDestination',
  HAS_NEW_POINT: 'hasNewPoint',
  GET_NEW_POINT: 'getNewPoint',
  GET_VIEW: 'getView',
  GET_LAYER_TREE: 'getLayerTree',
  PMR_CONFIG_VISIBLE: 'getPMRConfigVisibility',
  GET_PMR_PROFILE: 'getPRMProfile',
  GET_DEFAULT_PMR_PROFILE: 'getDefaultPRMProfile',
  GET_FEEDBACK: 'getFeedback',
  GET_ROUTE_COUNT: 'getRouteCount',
  GET_PRINTMODE: 'getPrintMode',
  GET_LONLAT: 'getLonLat',
  GET_INITIAL_BBOX: 'getInitialBbox',
  GET_HOME_POSITION: 'getHomePosition',
  IS_MUPI_MODE: 'isMupiMode',
  GET_FILTERING: 'getFiltering',
  GET_ZONAUBICACION: 'getZonaubicacion'
}

export const MUTATIONS = {
  SAVE_DEVICE_WIDTH: 'saveDeviceWidth',
  SAVE_IS_MOBILE: 'saveIsMobile',
  SAVE_CONFIG: 'saveConfig',
  SET_COORDINATES: 'setCoordinates',
  BLOCK_BBOX: 'blockBBOX',
  SAVE_BBOX: 'saveBBOX',
  SAVE_ACCESS_TOKEN: 'saveAccessToken',
  SAVE_AIRPORT: 'saveAirport',
  SAVE_CARTOGRAPHY_TILES: 'saveCartographyTiles',
  SAVE_POIS_CATALOG: 'savePoisCatalog',
  SAVE_POIS_LIST: 'savePoisList',
  SAVE_TRANSITION_POIS_LIST: 'saveTransitionPoisList',
  SAVE_UNCATEGORIZED_POIS_LIST: 'saveuncategorizedPoisList',
  SAVE_POI: 'savePoi',
  CLEAR_POI: 'clearPOI',
  SAVE_TILES_BUILDING_FLOOR: 'saveTilesBuildingFloor',
  SAVE_FLOOR: 'saveFloor',
  SAVE_ACTIVE_FILTERS: 'saveActiveFilters',
  SAVE_LAYER: 'saveLayer',
  SAVE_ROUTE: 'saveRoute',
  SAVE_DESTINATION_NAME_ROUTE: 'saveDestinationNameRoute',
  SAVE_ROUTE_MODE: 'saveRouteMode',
  SAVE_DEFAULT_LEVEL_BUILDING: 'saveDefaultLevelBuilding',
  SAVE_VIEW: 'saveView',
  REMOVE_LAYER: 'removeLayer',
  SAVE_PMR_CONFIG_VISIBILITY: 'SavePMRConfigVisibility',
  SAVE_PMR_PROFILE: 'savePMRProfile',
  SAVE_FEEDBACK: 'saveFeedback',
  SET_ROUTE_COUNT: 'setRouteCount',
  SAVE_HOME_POSITION: 'saveHomePosition',
  SAVE_FILTERING: 'saveFiltering'
}
